import { Route } from "@tanstack/react-router";
import { DashboardPage } from "../pages/DashboardPage";
import { rootRoute } from "./root";

export const indexRoute = new Route({
  getParentRoute: () => rootRoute,
  path: "/",
  component: DashboardPage,
});
